<!-- ✅ Modern Delete Profit Confirmation Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowDeleteProfitMessage" (click)="ShowDeleteProfitMessage = false;">
  <div class="ModernPopup" style="width: 420px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f44336;">warning</i>
        <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowDeleteProfitMessage = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p style="margin: 0; font-size: 13px; color: #5a7a9a;">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteProfitMessage = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteProfitMessage = false; DeleteProfitSettings();">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <span *ngIf="!this.parent.loading">{{ 'Configuration.DeleteYesButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Profit Settings Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowNewProfitSettings == true;" (click)="this.ShowNewProfitSettings = false;">
  <div class="ModernPopup" style="width: 600px; max-width: 90vw; max-height: 90vh;" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" *ngIf="this.ProfitSettings?.ID == 0 && !this.ProfitSettings.IsCopy;">add</i>
        <i class="material-icons" *ngIf="this.ProfitSettings?.ID > 0 && !this.ProfitSettings.IsCopy;">edit</i>
        <i class="material-icons" *ngIf="this.ProfitSettings.IsCopy == true;">content_copy</i>
        <span *ngIf="this.ProfitSettings?.ID == 0 && !this.ProfitSettings.IsCopy;">{{'AddNewProfitSettings' | translate}}</span>
        <span *ngIf="this.ProfitSettings?.ID > 0 && !this.ProfitSettings.IsCopy;">{{'ModifyProfitSettings' | translate}}</span>
        <span *ngIf="this.ProfitSettings.IsCopy == true;">{{'CopyProfitSettings' | translate}}</span>
      </div>
      <button class="ModernPopupClose" (click)="this.ShowNewProfitSettings = false;">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Body -->
    <div class="ModernPopupBody">
      <!-- Partner Search -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'SearchPartners' | translate}}*</label>
        <mat-form-field appearance="outline" style="width: 100%;">
          <input type="text"
                 placeholder="{{'SearchPartners' | translate}}"
                 matInput
                 (click)="InitializePartners();"
                 [matAutocomplete]="auto9"
                 [(ngModel)]="this.PartnerSearchTerm"
                 (ngModelChange)="this.partnerSearchTermUpdate.next($event)">
          <i class="material-icons" matSuffix *ngIf="this.PartnerSearchTerm?.length > 0;" (click)="this.ProfitSettings.PartnerID = null; this.ProfitSettings.PartnerName = ''; this.PartnerSearchTerm = null;" style="cursor: pointer;">close</i>
          <i class="material-icons" matSuffix *ngIf="(this.PartnerSearchTerm?.length > 0) != true;">search</i>
          <mat-autocomplete #auto9="matAutocomplete">
            <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.ProfitSettings.PartnerID = p.ID; this.ProfitSettings.PartnerName = p.Name; this.PartnerSearchTerm = p.Name;">
              {{p.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <!-- Our Profit (readonly) -->
      <div class="ModernFormGroup" *ngIf="this.ProfitSettings?.PercentageImpact?.PercentageProfitMargin != null">
        <label class="ModernFormLabel">% {{ 'OurProfit' | translate }}*</label>
        <input class="ModernFormInput" disabled="true" placeholder="{{ 'OurProfit' | translate }}*" autocomplete="off" [(ngModel)]="this.ProfitSettings.PercentageImpact.PercentageProfitMargin">
      </div>

      <!-- Configuration Search -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'SearchConfiguration' | translate}}*</label>
        <mat-form-field appearance="outline" style="width: 100%;">
          <input type="text"
                 placeholder="{{'SearchConfiguration' | translate}}"
                 matInput
                 (click)="InitializeImportConfigurations();"
                 [matAutocomplete]="auto3"
                 [(ngModel)]="this.ConfigurationTerm"
                 (ngModelChange)="this.configSearchTermUpdate.next($event)">
          <i class="material-icons" matSuffix *ngIf="this.ConfigurationTerm?.length > 0;" (click)="this.ProfitSettings.ImportConfiguration = null; this.ConfigurationTerm = ''; this.ProfitSettings.DiscountGroup = null;" style="cursor: pointer;">close</i>
          <i class="material-icons" matSuffix *ngIf="(this.ConfigurationTerm?.length > 0) != true;">search</i>
          <mat-autocomplete #auto3="matAutocomplete">
            <mat-option *ngFor="let c of ImportConfigurations" [value]="Configuration" (click)="SelectConfiguration(c);">
              {{c.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <!-- Discount Group -->
      <div class="ModernFormGroup" *ngIf="this.ProfitSettings?.ImportConfiguration?.DiscountedGroups?.length > 0;">
        <label class="ModernFormLabel">{{ 'SearchGroup' | translate }}</label>
        <div class="ModernDropdownContainer">
          <div class="ModernDropdownBar" (click)="discountGroupDropdownOpen = !discountGroupDropdownOpen">
            <span *ngIf="this.ProfitSettings.DiscountGroup != null">{{this.ProfitSettings.DiscountGroup.GroupName}} ({{this.ProfitSettings.DiscountGroup.DiscountValue}}% {{'PurchaseDiscount' | translate}})</span>
            <span *ngIf="this.ProfitSettings.DiscountGroup == null" style="color: #9ab;">{{ 'SearchGroup' | translate }}</span>
            <i class="material-icons">arrow_drop_down</i>
          </div>
          <div class="ModernDropdownResults" *ngIf="discountGroupDropdownOpen">
            <div class="ModernDropdownOption" *ngFor="let g of this.ProfitSettings?.ImportConfiguration?.DiscountedGroups" (click)="this.ProfitSettings.DiscountGroup = g; discountGroupDropdownOpen = false;">
              {{g.GroupName}} ({{g.DiscountValue}}% {{'PurchaseDiscount' | translate}})
            </div>
          </div>
        </div>
      </div>

      <!-- Brand Search -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{'SelectBrand' | translate}}</label>
        <mat-form-field appearance="outline" style="width: 100%;">
          <input type="text"
                 placeholder="{{'SelectBrand' | translate}}"
                 matInput
                 [matAutocomplete]="auto1"
                 [(ngModel)]="this.BrandSearchTerm"
                 (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                 (click)="InitializeBrands();">
          <i class="material-icons" matSuffix *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrandProfitSettings();" style="cursor: pointer;">close</i>
          <i class="material-icons" matSuffix *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
          <mat-autocomplete #auto1="matAutocomplete">
            <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; this.ProfitSettings.Brand = brand;">
              {{brand.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <!-- Percentage Impact -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'ProfitSettingsPercentageImpact' | translate }}</label>
        <div class="ModernDropdownContainer" matTooltip="{{this.ProfitSettings?.PercentageImpact?.Description}}" matTooltipClass='neutral-tool-tip-management'>
          <div class="ModernDropdownBar" (click)="percentageImpactDropdownOpen = !percentageImpactDropdownOpen">
            <span *ngIf="this.ProfitSettings.PercentageImpact != null">{{this.ProfitSettings.PercentageImpact.Name}}</span>
            <span *ngIf="this.ProfitSettings.PercentageImpact == null" style="color: #9ab;">{{ 'ProfitSettingsPercentageImpact' | translate }}</span>
            <i class="material-icons">arrow_drop_down</i>
          </div>
          <div class="ModernDropdownResults" *ngIf="percentageImpactDropdownOpen">
            <div class="ModernDropdownOption" *ngFor="let p of this.ProfitSettingsPercentageImpacts" (click)="this.ProfitSettings.PercentageImpact = p; percentageImpactDropdownOpen = false;">
              {{p.Name}}
            </div>
          </div>
        </div>
      </div>

      <!-- Percentage -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel" *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 0;">{{ 'PriceListDiscountClient' | translate }}*</label>
        <label class="ModernFormLabel" *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 1;">{{ 'PureProfitFromPurchasePrice' | translate }}*</label>
        <input class="ModernFormInput" placeholder="{{ 'Percentage' | translate }}*" autocomplete="off" [(ngModel)]="this.ProfitSettings.Percentage">
      </div>

      <!-- Extra Added Value -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'ExtraAddedValue' | translate }}*</label>
        <input class="ModernFormInput" placeholder="{{ 'ExtraAddedValue' | translate }}*" autocomplete="off" [(ngModel)]="this.ProfitSettings.ExtraAddedValue">
      </div>

      <!-- Extra Added Percentage Value -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'ExtraAddedPercentageValue' | translate }}*</label>
        <input class="ModernFormInput" placeholder="{{ 'ExtraAddedPercentageValue' | translate }}*" autocomplete="off" [(ngModel)]="this.ProfitSettings.ExtraAddedPercentageValue">
      </div>
    </div>

    <!-- Footer -->
    <div class="ModernPopupFooter">
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="this.ShowDeleteProfitMessage = true;">
        <i class="material-icons">delete</i>
        <span>{{'Delete' | translate}}</span>
      </button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="AddUpdatePartnerProfitSettings();" *ngIf="this.ProfitSettings.IsCopy != true;">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <i class="material-icons" *ngIf="!this.parent.loading">save_alt</i>
        <span>{{'SaveButton' | translate}}</span>
      </button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="AddUpdatePartnerProfitSettings();" *ngIf="this.ProfitSettings.IsCopy == true;">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <i class="material-icons" *ngIf="!this.parent.loading">content_copy</i>
        <span>{{'CopyProfitSettings' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Profit Settings Container Popup -->
<div class="ModernPopupOverlay" *ngIf="this.ShowProfitsContainer == true;" (click)="ShowProfitsContainer = false;">
  <div class="ModernPopup" style="width: 90vw; max-width: 1200px; max-height: 90vh;" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">monetization_on</i>
        <span>{{'ProfitSettings' | translate}}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowProfitsContainer = false;">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Body -->
    <div class="ModernPopupBody">
      <!-- Info Section -->
      <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 16px; padding: 12px; background: #f0f7ff; border-left: 3px solid #00aeef; border-radius: 8px;">
        <i class="material-icons" style="color: #00aeef;">info</i>
        <span style="font-size: 13px; color: #1a3a5c; font-weight: 500;" matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>Important</span>
      </div>

      <!-- Add New Button -->
      <div style="margin-bottom: 16px;">
        <button class="ModernButton primary" (click)="OpenNewProfitSettings();">
          <i class="material-icons">add</i>
          <span>{{'AddNewProfitSettings' | translate}}</span>
        </button>
      </div>

      <!-- Profit Settings Table -->
      <div class="ProfitSettingsTable">
        <div class="ProfitSettingsRow ProfitSettingsHeadder">
          <div class="ProfitSettingsCol" style="width: 5%;">
            <span>#</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 20%;">
            <span>{{'Client' | translate}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span>{{'DiscountGroup' | translate}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span>{{'ImportConfiguration' | translate}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span>{{'Brand' | translate}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span>{{'Percentage' | translate}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span>{{'Profit' | translate}}</span>
          </div>
        </div>

        <div class="ProfitSettingsRow" *ngFor="let ps of this.PartnerProfitSettings; let i=index;" (click)="EditProfitSettings(ps);">
          <div class="ProfitSettingsCol" style="width: 5%;">
            <span>{{i + 1}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 20%;">
            <span>{{ps.PartnerName}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
            <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span>{{ps.ImportConfiguration?.Name}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span>{{ps.Brand?.Name}}</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}%</span>
          </div>

          <div class="ProfitSettingsCol" style="width: 15%;">
            <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
          </div>
        </div>

      </div>
    </div>

    <!-- Footer -->
    <div class="ModernPopupFooter">
      <button class="ModernButton primary" (click)="ShowProfitsContainer = false;">
        <i class="material-icons">check</i>
        <span>{{'Ok' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Delete Logo Confirmation -->
<div class="ModernPopupOverlay" *ngIf="ShowDeleteLogoQuestion" (click)="ShowDeleteLogoQuestion = false;">
  <div class="ModernPopup" style="width: 420px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f44336;">warning</i>
        <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowDeleteLogoQuestion = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p style="margin: 0; font-size: 13px; color: #5a7a9a;">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteLogoQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteLogoQuestion = false;DeleteBrandLogo();">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <span *ngIf="!this.parent.loading">{{ 'Configuration.DeleteYesButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Delete Brand Confirmation -->
<div class="ModernPopupOverlay" *ngIf="ShowDeleteBrandQuestion" (click)="ShowDeleteBrandQuestion = false;">
  <div class="ModernPopup" style="width: 420px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f44336;">warning</i>
        <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowDeleteBrandQuestion = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p style="margin: 0; font-size: 13px; color: #5a7a9a;">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteBrandQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteBrandQuestion = false;DeleteBrand();">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <span *ngIf="!this.parent.loading">{{ 'Configuration.DeleteYesButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Delete Warehouse Confirmation -->
<div class="ModernPopupOverlay" *ngIf="ShowDeleteWarehouseQuestion" (click)="ShowDeleteWarehouseQuestion = false;">
  <div class="ModernPopup" style="width: 420px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f44336;">warning</i>
        <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowDeleteWarehouseQuestion = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p style="margin: 0; font-size: 13px; color: #5a7a9a;">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteWarehouseQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteWarehouseQuestion = false;DeleteWarehouse();">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <span *ngIf="!this.parent.loading">{{ 'Configuration.DeleteYesButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Delete Warehouse Zone Confirmation -->
<div class="ModernPopupOverlay" *ngIf="ShowDeleteWHZoneQuestion" (click)="ShowDeleteWHZoneQuestion = false;">
  <div class="ModernPopup" style="width: 420px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f44336;">warning</i>
        <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowDeleteWHZoneQuestion = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p style="margin: 0; font-size: 13px; color: #5a7a9a;">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteWHZoneQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteWHZoneQuestion = false;DeleteWHZone();">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <span *ngIf="!this.parent.loading">{{ 'Configuration.DeleteYesButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Delete Brand Exception Confirmation -->
<div class="ModernPopupOverlay" *ngIf="ShowDeleteBrandExceptionQuestion" (click)="ShowDeleteBrandExceptionQuestion = false;">
  <div class="ModernPopup" style="width: 420px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" style="color: #f44336;">warning</i>
        <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowDeleteBrandExceptionQuestion = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <p style="margin: 0; font-size: 13px; color: #5a7a9a;">{{ 'Configuration.DeleteQuestionDescription' | translate }}</p>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" [disabled]="this.parent.loading" (click)="ShowDeleteBrandExceptionQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button class="ModernButton danger" [disabled]="this.parent.loading" (click)="ShowDeleteBrandExceptionQuestion = false;DeleteBrandException();">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <span *ngIf="!this.parent.loading">{{ 'Configuration.DeleteYesButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Add New Brand Popup -->
<div class="ModernPopupOverlay" *ngIf="showAddNewBrand == true;" (click)="showAddNewBrand = false;">
  <div class="ModernPopup" style="width: 500px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">add</i>
        <span>{{ 'AddNewBrand' | translate }}</span>
      </div>
      <button class="ModernPopupClose" (click)="showAddNewBrand = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'BrandName' | translate }}*</label>
        <input class="ModernFormInput" placeholder="{{ 'BrandName' | translate }}*" autocomplete="off" [(ngModel)]="this.NewBrand.Name">
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'AlternativeName' | translate }}*</label>
        <input class="ModernFormInput" placeholder="{{ 'AlternativeName' | translate }}*" autocomplete="off" [(ngModel)]="this.NewBrand.Alternative">
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="showAddNewBrand = false;">{{ 'Cancel' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="AddUpdateBrand(this.NewBrand);">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <i class="material-icons" *ngIf="!this.parent.loading">add</i>
        <span>{{'AddNewBrand' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Add New Warehouse Popup -->
<div class="ModernPopupOverlay" *ngIf="showAddNewWarehouse == true;" (click)="showAddNewWarehouse = false;">
  <div class="ModernPopup" style="width: 500px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">add</i>
        <span>{{ 'AddNewWarehouse' | translate }} {{this.parent.Company.Name}}</span>
      </div>
      <button class="ModernPopupClose" (click)="showAddNewWarehouse = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'WarehouseName' | translate }}*</label>
        <input class="ModernFormInput" placeholder="{{ 'WarehouseName' | translate }}*" autocomplete="off" [(ngModel)]="this.NewWarehouse.Name">
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'WarehouseAddress' | translate }}</label>
        <div class="ModernDropdownContainer">
          <div class="ModernDropdownBar" (click)="newWarehouseAddressDropdownOpen = !newWarehouseAddressDropdownOpen">
            <span *ngIf="this.NewWarehouse.Address != null">{{this.NewWarehouse.Address.Country.Name}} {{this.NewWarehouse.Address.City}} {{this.NewWarehouse.Address.AddressLine}}</span>
            <span *ngIf="this.NewWarehouse.Address == null" style="color: #9ab;">{{ 'WarehouseAddress' | translate }}</span>
            <i class="material-icons">arrow_drop_down</i>
          </div>
          <div class="ModernDropdownResults" *ngIf="newWarehouseAddressDropdownOpen">
            <div class="ModernDropdownOption" *ngFor="let a of this.NewWarehouse.Company.Addresses" (click)="this.NewWarehouse.Address = a; newWarehouseAddressDropdownOpen = false;">
              {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="showAddNewWarehouse = false;">{{ 'Cancel' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="AddUpdateWarehouse(this.NewWarehouse);">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <i class="material-icons" *ngIf="!this.parent.loading">add</i>
        <span>{{'AddNewWarehouse' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Add/Edit Warehouse Zone Popup -->
<div class="ModernPopupOverlay" *ngIf="showAddNewWHZone == true;" (click)="showAddNewWHZone = false;">
  <div class="ModernPopup" style="width: 500px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" *ngIf="this.NewWHZone.ID == 0;">add</i>
        <i class="material-icons" *ngIf="this.NewWHZone.ID > 0;">edit</i>
        <span *ngIf="this.NewWHZone.ID == 0;">{{ 'AddWHZone' | translate }}: {{this.Warehouse.Name}}</span>
        <span *ngIf="this.NewWHZone.ID > 0;">{{ 'EditWHZone' | translate }}: {{this.Warehouse.Name}}</span>
      </div>
      <button class="ModernPopupClose" (click)="showAddNewWHZone = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'WHZoneName' | translate }}*</label>
        <input class="ModernFormInput" placeholder="{{ 'WHZoneName' | translate }}*" autocomplete="off" [(ngModel)]="this.NewWHZone.Name">
      </div>
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'WHZoneDescription' | translate }}</label>
        <textarea class="ModernFormTextarea" autocomplete="off" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" [(ngModel)]="this.NewWHZone.Description"></textarea>
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="showAddNewWHZone = false;">{{ 'Cancel' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="AddUpdateWHZone(this.NewWHZone);">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <i class="material-icons" *ngIf="!this.parent.loading && this.NewWHZone.ID == 0;">add</i>
        <i class="material-icons" *ngIf="!this.parent.loading && this.NewWHZone.ID > 0;">save_alt</i>
        <span *ngIf="this.NewWHZone.ID == 0;">{{'AddWHZone' | translate}}</span>
        <span *ngIf="this.NewWHZone.ID > 0;">{{'EditWHZone' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Brand Exception Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowAddNewBrandException == true;" (click)="ShowAddNewBrandException = false;">
  <div class="ModernPopup" style="width: 600px; max-width: 90vw; max-height: 90vh;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons" *ngIf="this.NewBrandException.ID == 0;">add</i>
        <i class="material-icons" *ngIf="this.NewBrandException.ID > 0;">edit</i>
        <span *ngIf="this.NewBrandException.ID == 0;">{{ 'AddBrandException' | translate }}: {{this.Brand?.Name}}</span>
        <span *ngIf="this.NewBrandException.ID > 0;">{{ 'EditBrandException' | translate }}: {{this.Brand?.Name}}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowAddNewBrandException = false;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <!-- Exception Type -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'ExceptionType' | translate }}*</label>
        <div class="ModernDropdownContainer">
          <div class="ModernDropdownBar" (click)="exceptionTypeDropdownOpen = !exceptionTypeDropdownOpen">
            <span *ngIf="this.NewBrandException.Type != null">{{this.NewBrandException.Type.Name}}</span>
            <span *ngIf="this.NewBrandException.Type == null" style="color: #9ab;">{{ 'ExceptionType' | translate }}</span>
            <i class="material-icons">arrow_drop_down</i>
          </div>
          <div class="ModernDropdownResults" *ngIf="exceptionTypeDropdownOpen">
            <div class="ModernDropdownOption" *ngFor="let type of this.BrandExceptionTypes" (click)="this.NewBrandException.Type = type; exceptionTypeDropdownOpen = false;">
              {{type.Name}}
            </div>
          </div>
        </div>
      </div>

      <!-- UIMessage - Only visible when Type.ID == 0 -->
      <div class="ModernFormGroup" *ngIf="this.NewBrandException.Type?.ID == 0">
        <label class="ModernFormLabel">{{ 'UIMessage' | translate }}*</label>
        <textarea class="ModernFormTextarea" placeholder="{{ 'UIMessage' | translate }}*" autocomplete="off" [(ngModel)]="this.NewBrandException.UIMessage" rows="3"></textarea>
      </div>

      <!-- NameInterdictions - Only visible when Type.ID == 1 -->
      <div class="ModernFormGroup" *ngIf="this.NewBrandException.Type?.ID == 1">
        <label class="ModernFormLabel">{{ 'NameInterdictions' | translate }}*</label>
        <textarea class="ModernFormTextarea" placeholder="{{ 'NameInterdictions' | translate }}*" autocomplete="off" [(ngModel)]="this.NewBrandException.NameInterdictions" rows="3"></textarea>
        <small style="font-size: 11px; color: #7a9ab8; margin-top: 4px; display: block;">{{ 'NameInterdictionsHint' | translate }}</small>
      </div>

      <!-- PartNumberInterdictions - Only visible when Type.ID == 1 -->
      <div class="ModernFormGroup" *ngIf="this.NewBrandException.Type?.ID == 1">
        <label class="ModernFormLabel">{{ 'PartNumberInterdictions' | translate }}*</label>
        <textarea class="ModernFormTextarea" placeholder="{{ 'PartNumberInterdictions' | translate }}*" autocomplete="off" [(ngModel)]="this.NewBrandException.PartNumberInterdictions" rows="3"></textarea>
        <small style="font-size: 11px; color: #7a9ab8; margin-top: 4px; display: block;">{{ 'PartNumberInterdictionsHint' | translate }}</small>
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="ShowAddNewBrandException = false;">{{ 'Cancel' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="AddUpdateBrandException();">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <i class="material-icons" *ngIf="!this.parent.loading">save_alt</i>
        <span *ngIf="this.NewBrandException.ID == 0;">{{'AddBrandException' | translate}}</span>
        <span *ngIf="this.NewBrandException.ID > 0;">{{'UpdateBrandException' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Lead Time Strategy Popup -->
<div class="ModernPopupOverlay" *ngIf="ShowChangeLeadTimeStrategyPopup == true;" (click)="ShowChangeLeadTimeStrategyPopup = false; SelectedLeadTimePriorityStrategy = null;">
  <div class="ModernPopup" style="width: 500px; max-width: 90vw;" (click)="$event.stopPropagation()">
    <div class="ModernPopupHeader">
      <div class="ModernPopupTitle">
        <i class="material-icons">schedule</i>
        <span>{{ 'ChangeBrandLeadTimeStrategy' | translate }}: {{this.Brand?.Name}}</span>
      </div>
      <button class="ModernPopupClose" (click)="ShowChangeLeadTimeStrategyPopup = false; SelectedLeadTimePriorityStrategy = null;">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="ModernPopupBody">
      <!-- Lead Time Strategy -->
      <div class="ModernFormGroup">
        <label class="ModernFormLabel">{{ 'LeadTimePriorityStrategy' | translate }}*</label>
        <div class="ModernDropdownContainer">
          <div class="ModernDropdownBar" (click)="leadTimeStrategyDropdownOpen = !leadTimeStrategyDropdownOpen">
            <span *ngIf="this.SelectedLeadTimePriorityStrategy != null">{{this.SelectedLeadTimePriorityStrategy.Name}}</span>
            <span *ngIf="this.SelectedLeadTimePriorityStrategy == null" style="color: #9ab;">{{ 'LeadTimePriorityStrategy' | translate }}</span>
            <i class="material-icons">arrow_drop_down</i>
          </div>
          <div class="ModernDropdownResults" *ngIf="leadTimeStrategyDropdownOpen">
            <div class="ModernDropdownOption" *ngFor="let strategy of this.LeadTimePriorityStrategies" (click)="this.SelectedLeadTimePriorityStrategy = strategy; leadTimeStrategyDropdownOpen = false;">
              {{strategy.Name}}
            </div>
          </div>
        </div>
      </div>

      <!-- Description Info Box -->
      <div *ngIf="SelectedLeadTimePriorityStrategy != null" style="margin-top: 10px; padding: 12px; background-color: #f0f7ff; border-left: 3px solid #4a7bb8; border-radius: 8px;">
        <p style="margin: 0; font-size: 13px; color: #1a3a5c;">
          <strong>{{ 'Description' | translate }}:</strong> {{SelectedLeadTimePriorityStrategy.Description}}
        </p>
      </div>
    </div>
    <div class="ModernPopupFooter">
      <button class="ModernButton outline" (click)="ShowChangeLeadTimeStrategyPopup = false; SelectedLeadTimePriorityStrategy = null;">{{ 'Cancel' | translate }}</button>
      <button class="ModernButton primary" [disabled]="this.parent.loading" (click)="UpdateBrandLeadTimeStrategy();">
        <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
        <i class="material-icons" *ngIf="!this.parent.loading">save_alt</i>
        <span>{{'Save' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<!-- ✅ Modern Main Content Container -->
<div class="ConfigurationsMainContent">
    <!-- Page Header -->
    <div class="ConfigurationsPageHeader">
        <i class="material-icons">construction</i>
        <span class="ConfigurationsPageTitle">{{'DataConfiguration' | translate}}</span>
    </div>

    <!-- Modern Tab Navigation -->
    <div class="animated fadeIn">
        <!-- GridModeTabsWrapper for Tab Navigation -->
        <div class="GridModeTabsWrapper">
          <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': selectedTab === 0}" (click)="onTabChange(0)">
            <i class="material-icons">label</i>
            <span>{{ 'Brands' | translate }}</span>
          </div>
          <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': selectedTab === 1}" (click)="onTabChange(1)">
            <i class="material-icons">warehouse</i>
            <span>{{ 'Warehouses' | translate }}</span>
          </div>
          <div class="GridModeTab" [ngClass]="{'SelectedGridModeTab': selectedTab === 2}" (click)="onTabChange(2)">
            <i class="material-icons">monetization_on</i>
            <span>{{ 'ProfitSettings' | translate }}</span>
          </div>
        </div>

        <!-- ✅ BRANDS TAB CONTENT -->
        <div *ngIf="selectedTab === 0">
          <div class="TabContainer">
            <!-- Tab Title with Brand Logo -->
            <div *ngIf="this.Brand != null;" class="TabTitle">
                {{this.Brand?.Name}}
                <div class="BrandTopLogoContainer" *ngIf="this.Brand?.LogoPath?.length > 0;">
                    <img [src]="this.parent.BackendServiceUrl + this.Brand?.LogoPath" />
                </div>
            </div>
            <p *ngIf="this.Brand == null;" class="TabTitle" style="border: none;">{{'Brands' | translate}}</p>

                <!-- Left Column: Brand Selection & Actions -->
                <div class="OneThirdColumn">
                    <!-- Brand Search Section -->
                    <div class="ModernSectionTitle">
                        <i class="material-icons">search</i>
                        <span>{{'SelectBrand' | translate}}</span>
                    </div>

                    <!-- Modern Brand Search -->
                    <div class="SearchBarContainer" style="margin-bottom: 16px;">
                      <div class="SearchBar">
                        <i class="material-icons">search</i>
                        <input class="SearchInput"
                               type="text"
                               placeholder="{{'SelectBrand' | translate}}"
                               [(ngModel)]="this.BrandFilter.SearchTerm"
                               (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                               (click)="InitializeBrands();"
                               (focus)="brandSearchFocused = true">
                        <i class="material-icons" *ngIf="this.BrandFilter?.SearchTerm?.length > 0;" (click)="ClearSearchBrand();" style="cursor: pointer; color: #5a7a9a;">close</i>
                      </div>

                      <!-- Search Results Dropdown -->
                      <div class="SearchResults" *ngIf="brandSearchFocused && Brands != null && Brands.length > 0 && this.BrandFilter?.SearchTerm?.length > 0">
                        <div class="SearchResultItem" *ngFor="let brand of Brands" (click)="this.Brand = brand; this.BrandFilter.SearchTerm = ''; brandSearchFocused = false; this.GetBrandExceptions();">
                          <i class="material-icons" style="color: #4a7bb8;">label</i>
                          <span>{{brand.Name}}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Overlay to close search results -->
                    <div class="SearchOverlayTransparent" *ngIf="brandSearchFocused" (click)="brandSearchFocused = false;"></div>

                    <!-- Action Buttons -->
                    <button class="ModernButton primary" style="width: 100%; margin-bottom: 12px;" (click)="OpenAddNewBrand();">
                        <i class="material-icons">add</i>
                        <span>{{'AddNewBrand' | translate}}</span>
                    </button>

                    <button class="ModernButton outline" style="width: 100%;" (click)="ShowProfitsContainer = true; GetPartnerProfitSettings();" *ngIf="this.Brand?.ID > 0;">
                        <i class="material-icons">radio_button_on</i>
                        <span>{{'ProfitSettings' | translate}}</span>
                    </button>

                    <!-- Brand Exceptions Section -->
                    <div *ngIf="this.Brand != null;" style="margin-top: 30px;">
                        <div class="ModernSectionTitle">
                          <i class="material-icons">rule</i>
                          <span>{{'BrandExceptions' | translate}}</span>
                        </div>

                        <button class="ModernButton success" style="width: 100%; margin-bottom: 12px; margin-top: 16px;" (click)="OpenAddNewBrandException();">
                            <i class="material-icons">add</i>
                            <span>{{'AddBrandException' | translate}}</span>
                        </button>

                        <button class="ModernButton outline" style="width: 100%; margin-bottom: 16px;" (click)="OpenChangeLeadTimeStrategyPopup();">
                            <i class="material-icons">schedule</i>
                            <span>{{'ChangeBrandLeadTimeStrategy' | translate}}</span>
                        </button>

                        <!-- Brand Exceptions List -->
                        <div class="BrandExceptionsTable" *ngIf="BrandExceptions != null && BrandExceptions.length > 0;" style="width: 100%; margin-top: 16px;">
                          <div class="BrandExceptionRow" *ngFor="let exception of this.BrandExceptions; let i=index;">
                            <div style="width: 100%;">
                              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                                <span style="font-weight: 600; color: #1a3a5c; font-size: 13px;">{{exception.Type?.Name}}</span>
                                <div style="display: flex; gap: 4px;">
                                  <button class="ModernActionButton primary" (click)="EditBrandExceptionModal(exception);" matTooltip="Edit">
                                    <i class="material-icons">edit</i>
                                  </button>
                                  <button class="ModernActionButton danger" (click)="PrepareDeleteBrandException(exception);" matTooltip="Delete">
                                    <i class="material-icons">delete</i>
                                  </button>
                                </div>
                              </div>

                              <!-- Display UIMessage if Type.ID == 0 -->
                              <div *ngIf="exception.Type?.ID == 0" style="font-size: 12px; color: #5a7a9a; margin-bottom: 4px;">
                                <strong>{{ 'UIMessage' | translate }}:</strong> {{exception.UIMessage}}
                              </div>

                              <!-- Display Name & Part Number Interdictions if Type.ID == 1 -->
                              <div *ngIf="exception.Type?.ID == 1">
                                <div style="font-size: 12px; color: #5a7a9a; margin-bottom: 4px;">
                                  <strong>{{ 'NameInterdictions' | translate }}:</strong> {{exception.NameInterdictions || 'N/A'}}
                                </div>
                                <div style="font-size: 12px; color: #5a7a9a;">
                                  <strong>{{ 'PartNumberInterdictions' | translate }}:</strong> {{exception.PartNumberInterdictions || 'N/A'}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- No Exceptions Message -->
                        <div *ngIf="BrandExceptions == null || BrandExceptions.length == 0;" style="margin-top: 16px; padding: 12px; color: #7a9ab8; font-size: 13px; text-align: center; background: #f8fbff; border-radius: 12px;">
                          <p style="margin: 0;">{{'NoBrandExceptions' | translate}}</p>
                        </div>

                        <!-- B2B Settings Section -->
                        <div *ngIf="BrandB2BSettings != null;" style="margin-top: 30px;">
                          <div class="ModernSectionTitle">
                            <i class="material-icons">tune</i>
                            <span>{{'B2BSettings' | translate}}</span>
                          </div>

                          <div class="ModernToggleContainer" style="margin-top: 16px;">
                            <label class="ModernToggle">
                              <input type="checkbox" [(ngModel)]="this.BrandB2BSettings.HideListPrice">
                              <span class="ModernToggleSlider"></span>
                            </label>
                            <span class="ModernToggleLabel">{{'HideListPrice' | translate}}</span>
                          </div>

                          <div class="ModernToggleContainer">
                            <label class="ModernToggle">
                              <input type="checkbox" [(ngModel)]="this.BrandB2BSettings.HideDelivery">
                              <span class="ModernToggleSlider"></span>
                            </label>
                            <span class="ModernToggleLabel">{{'HideDelivery' | translate}}</span>
                          </div>

                          <div class="ModernToggleContainer">
                            <label class="ModernToggle">
                              <input type="checkbox" [(ngModel)]="this.BrandB2BSettings.HideHSCode">
                              <span class="ModernToggleSlider"></span>
                            </label>
                            <span class="ModernToggleLabel">{{'HideHSCode' | translate}}</span>
                          </div>

                          <div class="ModernToggleContainer">
                            <label class="ModernToggle">
                              <input type="checkbox" [(ngModel)]="this.BrandB2BSettings.HideCOO">
                              <span class="ModernToggleSlider"></span>
                            </label>
                            <span class="ModernToggleLabel">{{'HideCOO' | translate}}</span>
                          </div>

                          <div class="ModernToggleContainer">
                            <label class="ModernToggle">
                              <input type="checkbox" [(ngModel)]="this.BrandB2BSettings.HideWeight">
                              <span class="ModernToggleSlider"></span>
                            </label>
                            <span class="ModernToggleLabel">{{'HideWeight' | translate}}</span>
                          </div>

                          <button class="ModernButton success" style="width: 100%;" (click)="UpdateBrandB2BSettings();">
                            <i class="material-icons">save</i>
                            <span>{{'UpdateB2BSettings' | translate}}</span>
                          </button>
                        </div>
                      </div>
                </div>

                <!-- Right Column: Brand Details -->
                <div class="TwoThirdsColumn" *ngIf="this.Brand != null;">
                    <!-- General Information Section -->
                    <div class="ModernSectionTitle">
                        <i class="material-icons">radio_button_checked</i>
                        <span>{{'GeneralInformation' | translate}}</span>
                    </div>

                    <!-- Brand Name -->
                    <div class="ModernFormGroup">
                        <label class="ModernFormLabel">{{ 'BrandName' | translate }}*</label>
                        <input class="ModernFormInput" placeholder="{{ 'BrandName' | translate }}*" autocomplete="off" [(ngModel)]="this.Brand.Name">
                    </div>

                    <!-- Alternative Name -->
                    <div class="ModernFormGroup">
                        <label class="ModernFormLabel">{{ 'AlternativeName' | translate }}*</label>
                        <input class="ModernFormInput" placeholder="{{ 'AlternativeName' | translate }}*" autocomplete="off" [(ngModel)]="this.Brand.Alternative">
                    </div>

                    <!-- Logo Path (readonly) -->
                    <div class="ModernFormGroup">
                        <label class="ModernFormLabel">{{ 'Logo' | translate }}*</label>
                        <input class="ModernFormInput" disabled="true" placeholder="{{ 'Logo' | translate }}*" autocomplete="off" [(ngModel)]="this.Brand.LogoPath">
                    </div>

                    <!-- Standard Percentage Profit -->
                    <div class="ModernFormGroup">
                        <label class="ModernFormLabel">{{ 'StandardPercentageProfit' | translate }}*</label>
                        <input class="ModernFormInput" placeholder="{{ 'StandardPercentageProfit' | translate }}*" autocomplete="off" [(ngModel)]="this.Brand.StandardPercentageProfit">
                    </div>

                    <!-- Rank -->
                    <div class="ModernFormGroup">
                        <label class="ModernFormLabel" matTooltip="{{'BrandRankDescription' | translate}}" matTooltipClass='neutral-tool-tip'>Rank</label>
                        <input class="ModernFormInput" type="number" [(ngModel)]="Brand.Rank" [min]="0" step="1" placeholder="Enter rank" />
                    </div>

                    <!-- Logo Upload Section -->
                    <div class="ModernSectionTitle" style="margin-top: 24px;">
                        <i class="material-icons">image</i>
                        <span>{{'Logo' | translate}}</span>
                    </div>

                    <div style="margin-top: 16px;">
                        <form [formGroup]="newBrandLogo" (ngSubmit)="AddUpdateBrandLogo()">
                          <div style="margin-bottom: 16px;">
                              <input type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" style="padding: 8px; border: 1px solid #d0e0f5; border-radius: 12px; width: 100%;">
                          </div>
                          <button type="submit" class="ModernButton primary">
                            <i class="material-icons">upload</i>
                            <span>{{ 'UploadLogo' | translate }}</span>
                          </button>
                        </form>
                      </div>

                      <!-- Action Buttons -->
                      <div style="margin-top: 24px; display: flex; gap: 12px; flex-wrap: wrap;">
                        <button class="ModernButton warning" style="flex: 1; min-width: 150px;" (click)="ShowDeleteLogoQuestion = true;">
                            <i class="material-icons">delete</i>
                            <span>{{'DeleteLogo' | translate}}</span>
                        </button>
                        <button class="ModernButton danger" style="flex: 1; min-width: 150px;" (click)="ShowDeleteBrandQuestion = true;">
                            <i class="material-icons">delete</i>
                            <span>{{'DeleteBrand' | translate}}</span>
                        </button>
                      </div>

                      <div style="margin-top: 16px;">
                        <button class="ModernButton primary" style="width: 100%;" [disabled]="this.parent.loading" (click)="AddUpdateBrand(this.Brand);">
                            <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
                            <i class="material-icons" *ngIf="!this.parent.loading">save_alt</i>
                            <span>{{'Update' | translate}}</span>
                        </button>
                      </div>

                    <!-- Brand Exceptions Table Section -->
                    <div class="ModernSectionTitle" style="margin-top: 32px;">
                        <i class="material-icons">rule</i>
                        <span>{{'BrandExceptions' | translate}}</span>
                    </div>

                    <!-- Brand Exceptions Table -->
                    <div class="BrandExceptionsContainer" *ngIf="BrandExceptions != null && BrandExceptions.length > 0;" style="margin-top: 16px;">
                      <div class="BrandExceptionsTable">
                        <div class="BrandExceptionsRow BrandExceptionsHeader">
                          <div class="BrandExceptionsCol" style="width: 5%;">
                            <span>#</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 20%;">
                            <span>{{'ExceptionType' | translate}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 25%;">
                            <span>{{'UIMessage' | translate}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 20%;">
                            <span>{{'NameInterdictions' | translate}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 20%;">
                            <span>{{'PartNumberInterdictions' | translate}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 10%;">
                            <span>{{'Actions' | translate}}</span>
                          </div>
                        </div>

                        <div class="BrandExceptionsRow" *ngFor="let exception of this.BrandExceptions; let i=index;">
                          <div class="BrandExceptionsCol" style="width: 5%;">
                            <span>{{i + 1}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 20%;">
                            <span>{{exception.Type?.Name}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 25%;">
                            <span>{{exception.UIMessage || '-'}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 20%;">
                            <span>{{exception.NameInterdictions || '-'}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 20%;">
                            <span>{{exception.PartNumberInterdictions || '-'}}</span>
                          </div>
                          <div class="BrandExceptionsCol" style="width: 10%; display: flex; gap: 8px; justify-content: center;">
                            <button class="ModernActionButton primary" (click)="EditBrandExceptionModal(exception);" matTooltip="Edit">
                              <i class="material-icons">edit</i>
                            </button>
                            <button class="ModernActionButton danger" (click)="PrepareDeleteBrandException(exception);" matTooltip="Delete">
                              <i class="material-icons">delete</i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- No Exceptions Message -->
                    <div *ngIf="BrandExceptions == null || BrandExceptions.length == 0;" style="margin-top: 16px; padding: 12px; color: #7a9ab8; font-size: 13px; text-align: center; background: #f8fbff; border-radius: 12px;">
                      <p style="margin: 0;">{{'NoBrandExceptions' | translate}}</p>
                    </div>

                </div>
              </div>
          </div>
        </div>

        <!-- ✅ WAREHOUSES TAB CONTENT -->
        <div *ngIf="selectedTab === 1">
          <div class="TabContainer">
            <!-- Tab Title -->
            <div *ngIf="this.Warehouse != null;" class="TabTitle">
                {{this.Warehouse?.Name}}
            </div>
            <p *ngIf="this.Warehouse == null;" class="TabTitle" style="border: none;">{{'Warehouses' | translate}}</p>

                <!-- Left Column: Warehouse Selection & Actions -->
                <div class="OneThirdColumn">
                    <!-- Warehouse Search Section -->
                    <div class="ModernSectionTitle">
                        <i class="material-icons">search</i>
                        <span>{{'SelectWarehouse' | translate}}</span>
                    </div>

                    <!-- Modern Warehouse Search -->
                    <div class="SearchBarContainer" style="margin-bottom: 16px;">
                      <div class="SearchBar">
                        <i class="material-icons">search</i>
                        <input id="warehouseselectid"
                               class="SearchInput"
                               type="text"
                               placeholder="{{'SelectWarehouse' | translate}}"
                               [(ngModel)]="this.WarehouseFilter.SearchTerm"
                               (ngModelChange)="this.warehouseSearchTermUpdate.next($event)"
                               (click)="InitializeWarehouses();"
                               (focus)="warehouseSearchFocused = true">
                        <i class="material-icons" *ngIf="this.WarehouseFilter?.SearchTerm?.length > 0;" (click)="ClearSearchWarehouse();" style="cursor: pointer; color: #5a7a9a;">close</i>
                      </div>

                      <!-- Search Results Dropdown -->
                      <div class="SearchResults" *ngIf="warehouseSearchFocused && Warehouses != null && Warehouses.length > 0 && this.WarehouseFilter?.SearchTerm?.length > 0">
                        <div class="SearchResultItem" *ngFor="let warehouse of this.Warehouses" (click)="this.Warehouse = warehouse; this.WarehouseFilter.SearchTerm = ''; warehouseSearchFocused = false; GetWarehouse(this.Warehouse.ID);">
                          <i class="material-icons" style="color: #4a7bb8;">warehouse</i>
                          <span>{{warehouse.Name}}</span>
                        </div>
                      </div>
                    </div>

                    <!-- Overlay to close search results -->
                    <div class="SearchOverlayTransparent" *ngIf="warehouseSearchFocused" (click)="warehouseSearchFocused = false;"></div>

                    <!-- Add New Warehouse Button -->
                    <button class="ModernButton primary" style="width: 100%; margin-bottom: 16px;" (click)="OpenAddNewWarehouse();">
                        <i class="material-icons">add</i>
                        <span>{{'AddNewWarehouse' | translate}}</span>
                    </button>

                    <!-- Action Buttons (when warehouse selected) -->
                    <div *ngIf="this.Warehouse != null;" style="margin-top: 32px;">
                      <button class="ModernButton danger" style="width: 100%; margin-bottom: 12px;" (click)="ShowDeleteWarehouseQuestion = true;">
                            <i class="material-icons">delete</i>
                            <span>{{'DeleteWarehouse' | translate}}</span>
                      </button>

                      <button class="ModernButton primary" style="width: 100%;" [disabled]="this.parent.loading" (click)="AddUpdateWarehouse(this.Warehouse);">
                            <i class="material-icons spinner" *ngIf="this.parent.loading">refresh</i>
                            <i class="material-icons" *ngIf="!this.parent.loading">save_alt</i>
                            <span>{{'Update' | translate}}</span>
                      </button>
                    </div>
                </div>

                <!-- Right Column: Warehouse Details -->
                <div class="TwoThirdsColumn" *ngIf="this.Warehouse != null;">
                  <!-- General Information Section -->
                  <div class="ModernSectionTitle">
                    <i class="material-icons">radio_button_checked</i>
                    <span>{{'GeneralInformation' | translate}}</span>
                  </div>

                  <!-- Warehouse Name -->
                  <div class="ModernFormGroup">
                    <label class="ModernFormLabel">{{ 'WarehouseName' | translate }}*</label>
                    <input class="ModernFormInput" placeholder="{{ 'WarehouseName' | translate }}*" autocomplete="off" [(ngModel)]="this.Warehouse.Name">
                  </div>

                  <!-- Is Partner Warehouse Toggle -->
                  <div class="ModernToggle" style="margin-bottom: 16px;">
                    <label class="ModernToggleLabel">
                      <input type="checkbox" [(ngModel)]="this.Warehouse.IsPartnerWarehouse">
                      <span class="ModernToggleSlider"></span>
                      <span class="ModernToggleText">{{'IsPartnerWarehouse' | translate}}</span>
                    </label>
                  </div>

                  <!-- Selected Partner Info -->
                  <div *ngIf="this.Warehouse.Partner != null && this.Warehouse.IsPartnerWarehouse == true;" style="padding: 12px; background: #f0f7ff; border-left: 3px solid #4a7bb8; border-radius: 8px; margin-bottom: 16px;">
                    <p style="margin: 0; font-size: 13px; color: #1a3a5c;">
                      <strong>{{'SelectedPartner' | translate}}:</strong> {{Warehouse.Partner.Name}}
                    </p>
                  </div>

                  <!-- Partner Selection (if Partner Warehouse) -->
                  <div class="ModernFormGroup" *ngIf="this.Warehouse.IsPartnerWarehouse == true;">
                    <label class="ModernFormLabel">{{'SelectPartner' | translate}}</label>
                    <mat-form-field appearance="outline" style="width: 100%;">
                      <input type="text"
                             placeholder="{{'SelectPartner' | translate}}"
                             matInput
                             [matAutocomplete]="auto11"
                             [(ngModel)]="this.PartnersFilter.SearchTerm"
                             (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                             (click)="InitializePartners();">
                      <mat-autocomplete #auto11="matAutocomplete">
                        <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.Warehouse.Partner = p; this.PartnersFilter.SearchTerm = p.Name;">
                          {{p.Name}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>

                  <!-- Active Address Info -->
                  <div *ngIf="this.Warehouse.Address != null && this.Warehouse.IsPartnerWarehouse == true;" style="padding: 12px; background: #f0f7ff; border-left: 3px solid #4a7bb8; border-radius: 8px; margin-bottom: 16px;">
                    <p style="margin: 0; font-size: 13px; color: #1a3a5c;">
                      <strong>{{'ActiveAddress' | translate}}:</strong> {{Warehouse.Address?.City}} {{Warehouse.Address?.AddressLine}}
                    </p>
                  </div>

                  <!-- Address Selection (if Partner Warehouse) -->
                  <div class="ModernFormGroup" *ngIf="this.Warehouse.IsPartnerWarehouse == true;">
                    <label class="ModernFormLabel">{{'SelectAddress' | translate}}</label>
                    <mat-form-field appearance="outline" style="width: 100%;">
                      <input type="text"
                             placeholder="{{'SelectAddress' | translate}}"
                             matInput
                             [matAutocomplete]="auto10"
                             [(ngModel)]="this.AddressesFilter.Product"
                             (ngModelChange)="this.addressSearchTermUpdate.next($event)"
                             (click)="InitializeAddresses();">
                      <mat-autocomplete #auto10="matAutocomplete">
                        <mat-option *ngFor="let a of Addresses" [value]="a" (click)="this.Warehouse.Address = a; this.AddressesFilter.Product = a.City +' '+ a.AddressLine;">
                          {{a.City}}, {{a.AddressLine}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>

                  <!-- Warehouse Address (if NOT Partner Warehouse) -->
                  <div class="ModernFormGroup" *ngIf="this.Warehouse.IsPartnerWarehouse != true;">
                    <label class="ModernFormLabel">{{ 'WarehouseAddress' | translate }}</label>
                    <div class="ModernDropdownContainer">
                      <div class="ModernDropdownBar" (click)="warehouseAddressDropdownOpen = !warehouseAddressDropdownOpen">
                        <span *ngIf="this.Warehouse.Address != null">{{this.Warehouse.Address.Country.Name}} {{this.Warehouse.Address.City}} {{this.Warehouse.Address.AddressLine}}</span>
                        <span *ngIf="this.Warehouse.Address == null" style="color: #9ab;">{{ 'WarehouseAddress' | translate }}</span>
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                      <div class="ModernDropdownResults" *ngIf="warehouseAddressDropdownOpen">
                        <div class="ModernDropdownOption" *ngFor="let a of this.Warehouse.Company.Addresses" (click)="this.Warehouse.Address = a; warehouseAddressDropdownOpen = false;">
                          {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Lead Time Settings -->
                  <div class="ModernFormRow" *ngIf="this.Warehouse.StockLeadTime != null" style="display: flex; gap: 12px; align-items: flex-end;">
                    <div class="ModernFormGroup" style="flex: 0 0 100px;">
                      <label class="ModernFormLabel">{{'Units' | translate}}</label>
                      <input class="ModernFormInput" placeholder="{{'Units' | translate}}" autocomplete="off" [(ngModel)]="this.Warehouse.StockLeadTime.Units">
                    </div>

                    <div class="ModernFormGroup" style="flex: 1;">
                      <label class="ModernFormLabel">{{ 'LeadTimeType' | translate }}</label>
                      <div class="ModernDropdownContainer">
                        <div class="ModernDropdownBar" (click)="leadTimeTypeDropdownOpen = !leadTimeTypeDropdownOpen">
                          <span *ngIf="this.Warehouse.StockLeadTime.Type != null">{{this.Warehouse.StockLeadTime.Type.Name}}</span>
                          <span *ngIf="this.Warehouse.StockLeadTime.Type == null" style="color: #9ab;">{{ 'LeadTimeType' | translate }}</span>
                          <i class="material-icons">arrow_drop_down</i>
                        </div>
                        <div class="ModernDropdownResults" *ngIf="leadTimeTypeDropdownOpen">
                          <div class="ModernDropdownOption" *ngFor="let t of this.LeadTimeTypes" (click)="this.Warehouse.StockLeadTime.Type = t; leadTimeTypeDropdownOpen = false;">
                            {{t.Name}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Is Work Days Toggle -->
                  <div class="ModernToggle" *ngIf="this.Warehouse.StockLeadTime?.Type != null;" style="margin-bottom: 24px;">
                    <label class="ModernToggleLabel">
                      <input type="checkbox" [(ngModel)]="this.Warehouse.StockLeadTime.Type.IsWorkDays">
                      <span class="ModernToggleSlider"></span>
                      <span class="ModernToggleText">{{'IsWorkDays' | translate}}</span>
                    </label>
                  </div>

                  <!-- Warehouse Zones Section -->
                  <div class="ModernSectionTitle" style="margin-top: 24px;">
                    <i class="material-icons">location_on</i>
                    <span>{{'WarehouseZones' | translate}}</span>
                  </div>

                  <!-- Warehouse Zones List -->
                  <div class="ModernWarehouseZonesList" *ngIf="WHZones != null && WHZones.length > 0;" style="margin-top: 16px;">
                    <div *ngFor="let zone of this.WHZones" class="ModernWarehouseZone">
                      <div class="ModernWarehouseZoneIcon">
                        <i class="material-icons">location_on</i>
                      </div>
                      <span class="ModernWarehouseZoneName">{{zone.Name}}</span>
                      <div style="display: flex; gap: 4px; margin-left: auto;">
                        <button class="ModernActionButton primary" (click)="this.NewWHZone = zone;this.showAddNewWHZone = true;" matTooltip="Edit">
                          <i class="material-icons">edit</i>
                        </button>
                        <button class="ModernActionButton danger" (click)="this.NewWHZone = zone; this.ShowDeleteWHZoneQuestion = true;" matTooltip="Delete">
                          <i class="material-icons">delete</i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Add Zone Button -->
                  <div style="margin-top: 16px;">
                    <button class="ModernButton success" style="width: 100%;" (click)="OpenAddNewWHZone();">
                        <i class="material-icons">add</i>
                        <span>{{'AddWHZone' | translate}}</span>
                    </button>
                  </div>

                </div>
              </div>
          </div>
        </div>

        <!-- ✅ PROFIT SETTINGS TAB CONTENT -->
        <div *ngIf="selectedTab === 2">
          <div class="TabContainer">
            <p class="TabTitle" style="border: none;">{{'ProfitSettings' | translate}}</p>

                <div class="TabProfitsContainer">
                  <!-- Section Title -->
                  <div class="ModernSectionTitle">
                    <i class="material-icons">monetization_on</i>
                    <span>{{'ProfitSettings' | translate}}</span>
                  </div>

                  <!-- Info Section -->
                  <div style="display: flex; align-items: center; gap: 8px; margin-top: 16px; padding: 12px; background: #f0f7ff; border-left: 3px solid #00aeef; border-radius: 8px;">
                    <i class="material-icons" style="color: #00aeef;">info</i>
                    <span style="font-size: 13px; color: #1a3a5c; font-weight: 500;" matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>Important</span>
                  </div>

                  <div style="margin-top: 24px;">
                    <!-- Add New Profit Settings Button -->
                    <div style="margin-bottom: 16px;">
                      <button class="ModernButton primary" (click)="OpenNewProfitSettings();">
                        <i class="material-icons">add</i>
                        <span>{{'AddNewProfitSettings' | translate}}</span>
                      </button>
                    </div>

                    <!-- Profit Settings Table -->
                    <div class="ProfitSettingsTable">
                      <div class="ProfitSettingsRow ProfitSettingsHeadder">
                        <div class="ProfitSettingsCol" style="width: 5%;">
                          <span>#</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 20%;">
                          <span>{{'Client' | translate}}</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 15%;">
                          <span>{{'DiscountGroup' | translate}}</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 15%;">
                          <span>{{'ImportConfiguration' | translate}}</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 15%;">
                          <span>{{'Brand' | translate}}</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 15%;">
                          <span>{{'Percentage' | translate}}</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 10%;">
                          <span>{{'Profit' | translate}}</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 5%;">
                          <span>{{'Actions' | translate}}</span>
                        </div>
                      </div>

                      <!-- Profit Settings Rows -->
                      <div class="ProfitSettingsRow" *ngFor="let ps of this.PartnerProfitSettings; let i=index;">
                        <div class="ProfitSettingsCol" style="width: 5%;" (click)="EditProfitSettings(ps);">
                          <span>{{i + 1}}</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 20%;" (click)="EditProfitSettings(ps);">
                          <span *ngIf="ps.PartnerName != null && ps.PartnerName?.length > 0;">{{ps.PartnerName}}</span>
                          <span *ngIf="ps.PartnerName == null || ps.PartnerName?.length == 0;">-----</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                          <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
                          <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
                          <span *ngIf="ps.DiscountGroup == null;">-----</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                          <span *ngIf="ps.ImportConfiguration != null;">{{ps.ImportConfiguration?.Name}}</span>
                          <span *ngIf="ps.ImportConfiguration == null;">-----</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                          <span *ngIf="ps.Brand != null;">{{ps.Brand?.Name}}</span>
                          <span *ngIf="ps.Brand == null;">-----</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                          <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}% {{ps.PercentageImpact?.Name}}</span>
                          <span *ngIf="ps.Percentage == null;">-----</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 10%;" (click)="EditProfitSettings(ps);">
                          <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
                          <span *ngIf="ps.PercentageImpact == null;">-----</span>
                        </div>

                        <div class="ProfitSettingsCol" style="width: 5%;">
                          <button class="ModernActionButton primary" (click)="CopyProfitSettingsUI(ps);" matTooltip="Copy">
                            <i class="material-icons">content_copy</i>
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>

          </div>
        </div>
